'use strict';
import { Component, Inject, Input, Output, EventEmitter, OnInit} from 'ng-metadata/core';
var angular:angular.IAngularStatic =  require('angular');

@Component({
    "selector": "prm-refworks",
    templateUrl: 'components/search/actions/refworksAction/refworks.html'
})


export class PrmRefworks implements OnInit {
    @Output() closeTabsEvent= new EventEmitter<void>();

    constructor() {
    }

    ngOnInit() {
        this.closeTabsEvent.emit(null);
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/refworksAction/refworks.directive.ts